import axios from 'axios';

const baseUrl = window.config.API_URL;

const gettingImageGrid = async (state) => {
  const data = {
    optionId: state?.optionId,
    user_id: state?.user_id,
    link_id: state?.link_id,
    coloum_type: state?.coloum_type,
    coloum_name: state?.coloum_name,
    id: state?.id,
  };
  const datass = JSON.stringify(data);

  const path = `/api/user/createImageGrid`;
  const token = JSON.parse(localStorage.getItem('user')).token;
  const bodyFormData = new FormData();
  state?.picture.forEach((image) => {
    bodyFormData.append('picture', image);
  });
  bodyFormData.append('data', datass);
  const url = baseUrl + path;
  const response = await axios.post(url, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `'Bearer'${token}`,
    },
  });

  return response.data;
};

const ImageGridService = {
  gettingImageGrid,
};

export default ImageGridService;
